module.exports = __webpack_public_path__ + "img/three-pointers.b7728600.svg";